import type { ColumnDefinition } from '@trm/ui-kit-admin';

export const ACCOUNTS_TABLE_ID = 'admin-accounts-v2';
export const accountColumns: readonly ColumnDefinition[] = [
  { key: 'id', label: 'ID', locked: true },
  { key: 'account', label: 'Name' },
  { key: 'subscription', label: 'Sub ID' },
  { key: 'email', label: 'Email' },
  { key: 'fullName', label: 'Full Name' },
  { key: 'username', label: 'Username' },
  { key: 'verification', label: 'Veriff Status' },
  { key: 'riskLabels', label: 'Risk Labels' },
  { key: 'product', label: 'Buying Power' },
  { key: 'type', label: 'Type' },
  { key: 'balance', label: 'Balance' },
  { key: 'dll', label: 'DLL' },
  { key: 'startDate', label: 'Start Date' },
  { key: 'closedAt', label: 'Closed Date' },
  { key: 'eligible', label: 'Eligible' },
  { key: 'status', label: 'Status' },
  { key: 'stage', label: 'Stage' },
  { key: 'complimentary', label: 'Complimentary' },
  { key: 'alerts', label: 'Alerts' },
  { key: 'view', label: 'View' },
];
